import store from '@/core/store'
import { setMeField } from '@/core/store/Slices/MeSlice'
import { cancelCustomerSubscription, reactivateSubscription, getCustomerBillingData, queryCancelSubscriptionData, cancelTrialSubscription } from '@/core/http/me.api'

class BillingService {
  async cancelSubscription (type) {
    await cancelCustomerSubscription(type)
  }

  async cancelTrialSubscription () {
    await cancelTrialSubscription()
  }

  async reactivateSubscription () {
    await reactivateSubscription()
  }

  async getCancelSubscriptionData () {
    const data = await queryCancelSubscriptionData()
    return data
  }

  async setBillingInfo () {
    const data = await getCustomerBillingData()
    store.dispatch(setMeField({ field: 'billing', value: data.billingData }))
  }
}

export default new BillingService()
